import { ConfigService } from '@core/shared/config';
import { RouterLinkResolverService } from '@core/shared/feature';
import { DevToolsRegistry } from '../../dev-tools';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/feature";
import * as i2 from "@core/shared/config";
import * as i3 from "../../dev-tools";
export let FeatureRouterLinkResolverService = /*#__PURE__*/(() => {
  class FeatureRouterLinkResolverService {
    constructor(resolverService, config, debug) {
      this.resolverService = resolverService;
      this.config = config;
      debug.exposeDebugFunction(['Features', 'RouterLinkResolvers'], () => {
        return this.resolverService.getRouterLinkResolversForAllPlatforms();
      });
    }
    resolveRouterLink(name, info, allowUndefined = false) {
      const platform = this.config.getPlatform();
      return this.resolverService.resolveRouterLink(platform, name, info, allowUndefined);
    }
    resolveToFullLink(name, info) {
      const platform = this.config.getPlatform();
      const routerLink = this.resolveRouterLink(name, info);
      const link = this.config.buildPlatformUrl(platform, true, routerLink.join('/'));
      return link;
    }
    resolveRouterLinkForPlatform(platform, name, info, allowUndefined = false) {
      return this.resolverService.resolveRouterLink(platform, name, info, allowUndefined);
    }
    resolveToFullLinkForPlatform(platform, name, info) {
      const routerLink = this.resolveRouterLinkForPlatform(platform, name, info);
      const link = this.config.buildPlatformUrl(platform, true, routerLink.join('/'));
      return link;
    }
    static {
      this.ɵfac = function FeatureRouterLinkResolverService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeatureRouterLinkResolverService)(i0.ɵɵinject(i1.RouterLinkResolverService), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FeatureRouterLinkResolverService,
        factory: FeatureRouterLinkResolverService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FeatureRouterLinkResolverService;
})();